const capsule = 'capsule';
const chewable = 'chewable';

function calculate_age(dob) {
    var now = new Date();
    var age = now.getFullYear() - dob.getFullYear();
    var m = now.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && now.getDate() < dob.getDate())) {
        age--;
    }
    return age;
}

document.addEventListener("DOMContentLoaded", function () {
  const hsfExistingForm = getCookie("hsf-form-obj");
  if (hsfExistingForm) {
    const formObj = JSON.parse(hsfExistingForm);
    if (formObj) {
      const { first_name, last_name, day, month, year } = formObj;
      if (first_name) document.getElementById('first_name').value = first_name;
      if (last_name) document.getElementById('last_name').value = last_name;
      if (day) document.getElementById('day').value = day;
      if (month) document.getElementById('month').value = month;
      if (year) document.getElementById('year').value = year;
    }
  }
});

function formValidationError(first_name, last_name, month, year, day) {
  let formError = false;
  if (first_name.value == '') {
    document.querySelector(
      "form .error-msg.first-name"
    ).innerHTML = KROWN.settings.hsf.hsf_form_field_error;
    first_name.classList.add('error');
    formError = true;
  }
  if (last_name.value == '') {
    document.querySelector(
      "form .error-msg.last-name"
    ).innerHTML = KROWN.settings.hsf.hsf_form_field_error;
    last_name.classList.add('error');
    formError = true;
  }
  if (month.value == '' || year.value == '' || day.value == '') {
    document.querySelector(
      "form .error-msg.birth-date"
    ).innerHTML = KROWN.settings.hsf.hsf_form_field_error;
    if (month.value == '') month.classList.add('error');
    if (year.value == '') year.classList.add('error');
    if (day.value == '') day.classList.add('error');
    formError = true;
  }
  if (formError) {
    return true;
  }
  return false;
}

function clearErrorMsg() {
  document.querySelectorAll('#HSFChildForm .form-input-field').forEach(function(elm) {
    elm.classList.remove('error');
  })
  document.querySelectorAll("form .error-msg").forEach(elm=>{
    elm.innerHTML = '';
  });
}

const inputFields = document.querySelectorAll('#HSFChildForm .form-input-field');
inputFields.forEach(function(elm) {
  elm.addEventListener('change', function() {
    let termsCheck = document.getElementById("terms_check").checked;
    if (termsCheck) {
      document.getElementById("terms_check").checked = false;
      clearErrorMsg();
      document.getElementById("childSectionHeading").classList.add("hidden");
      document.getElementById("childSectionProducts").classList.add("hidden");
      document.getElementById("childSectionHeading").classList.remove("grid");
      document.getElementById("childSectionProducts").classList.remove("grid");
      if (!document.querySelector(".bundler-child-form").classList.contains("bundler-form--empty")) {
        document.querySelector(".bundler-child-form").classList.add("bundler-form--empty");
      }
      if (document.getElementById("hsf-component").classList.contains("bundler-full")) {
        document.getElementById("hsf-component").classList.remove("bundler-full");
      }
    }
  });
});

function hasValidHSFChildAndAdultProduct() {
  let adultItemCount = 0;
  let childItemCount = 0;
  let hasEmptySlot = false;
  document.querySelectorAll(".bundler__content-products .bundler-product").forEach((elm) => {
    if (elm.dataset.adultProduct) {
      adultItemCount++;
    } else if(elm.dataset.childProduct) {
      childItemCount++;
    }
    if (elm.classList.contains("bundler-product--empty")) {
      hasEmptySlot = true;
    }
  });
  if (adultItemCount > 0 && childItemCount > 0 && !hasEmptySlot ) {
    return true;
  }
  return false;
}

document.getElementById("terms_check").addEventListener("click", function (e) {
  clearErrorMsg();
  if (this.checked) {
    var elements = document.getElementById("HSFChildForm").elements;
    const { first_name, last_name, month, year, day, terms_check } = elements;
    if (formValidationError(first_name, last_name, month, year, day)) {
      return true;
    }
    const formObj = {
      first_name: first_name.value,
      last_name: last_name.value,
      year: year.value,
      day: day.value,
      month: month.value,
    };
    const dateStr = formObj.year + "/" + formObj.month + "/" + formObj.day;
    const birthDate = new Date(dateStr);
    const currentDate = new Date();
    if (isNaN(birthDate) || birthDate > currentDate) {
      document.querySelector(
        "form .error-msg.birth-date"
      ).innerHTML = `<span>Please enter valid birth date</span>`;
      month.classList.add('error');
      year.classList.add('error');
      day.classList.add('error');
      return true;
    }
    const age = calculate_age(birthDate);
    if (age >= 4 && age < 25) {
      const child_products = document.querySelectorAll("#childSectionProducts .product-item");
      child_products.forEach(elm => {
          let min_capsule_age = elm.getAttribute('data-hsf_min_age_for_capsules');
          let max_capsule_age = elm.getAttribute('data-hsf_max_age_for_capsules');
          if(max_capsule_age){
            if ( age >= parseInt(max_capsule_age)) { 
              elm.classList.add('hidden');
            } else {
              elm.classList.remove('hidden');
            }
          } else if(min_capsule_age) {
            if ( age < parseInt(min_capsule_age)) { 
              elm.classList.add('hidden');
            } else {
              elm.classList.remove('hidden');
            }
          }
      });
      document.getElementById("childSectionHeading").classList.remove("hidden");
      document.getElementById("childSectionProducts").classList.remove("hidden");
      document.getElementById("childSectionHeading").classList.add("grid");
      document.getElementById("childSectionProducts").classList.add("grid");
      document.querySelector(".bundler-child-form").classList.remove("bundler-form--empty");
      setCookie("hsf-form-obj", JSON.stringify(formObj), 30);
      if (hasValidHSFChildAndAdultProduct()) {
        document.getElementById("hsf-component").classList.add("bundler-full");
      }
    } else {
      document.querySelector(
        "form .error-msg.birth-date"
      ).innerHTML = `<span>Please enter valid birth date between 4 to 25 years</span>`;
      month.classList.add('error');
      year.classList.add('error');
      day.classList.add('error');
    }
  } else {
    document.getElementById("childSectionHeading").classList.add("hidden");
    document.getElementById("childSectionProducts").classList.add("hidden");
    document.getElementById("childSectionHeading").classList.remove("grid");
    document.getElementById("childSectionProducts").classList.remove("grid");
    if (!document.querySelector(".bundler-child-form").classList.contains("bundler-form--empty")) {
      document.querySelector(".bundler-child-form").classList.add("bundler-form--empty");
    }
    if (document.getElementById("hsf-component").classList.contains("bundler-full")) {
      document.getElementById("hsf-component").classList.remove("bundler-full");
    }
  }
});
